import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { SidebarComponent } from './components/sidebar/sidebar';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, FooterComponent, SidebarComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected title = 'stitch-app';
  constructor(private router: Router) {}

  isAuthRoute(): boolean {
    return this.router.url.startsWith('/auth');
  }

  isNoSidebarRoute(): boolean {
    const url = this.router.url;
    return (
      url.startsWith('/auth') ||
      url.startsWith('/privacy-policy') ||
      url.startsWith('/terms-and-conditions')
    );
  }

  isChatHistoryRoute(): boolean {
    // Matches routes like /chat/:bot_id/:user_id
    return /^\/chat\/[^\/]+\/.+/.test(this.router.url);
  }
}
